import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface RealPlayerNews {
  id: string;
  headline: string;
  summary: string | null;
  source: string | null;
  news_type: string | null;
  created_at: string;
}

export interface PlayerSeasonStats {
  games_played: number;
  at_bats: number;
  hits: number;
  home_runs: number;
  rbi: number;
  runs_scored: number;
  stolen_bases: number;
  strikeouts: number;
  walks_drawn: number;
  errors: number;
  innings_pitched: number;
  pitcher_wins: number;
  pitcher_losses: number;
  pitcher_strikeouts: number;
  earned_runs: number;
  saves: number;
  holds: number;
  is_pitcher: boolean;
}

export function usePlayerProfile(playerName: string, enabled: boolean) {
  const [news, setNews] = useState<RealPlayerNews[]>([]);
  const [stats, setStats] = useState<PlayerSeasonStats | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!playerName || !enabled) return;
    setLoading(true);

    const fetchData = async () => {
      // Fetch news by player name
      const { data: newsData } = await supabase
        .from('player_news' as any)
        .select('id, headline, summary, source, news_type, created_at')
        .eq('player_name', playerName)
        .order('created_at', { ascending: false })
        .limit(10);

      if (newsData) setNews(newsData as any as RealPlayerNews[]);

      // Fetch player ID then season stats
      const { data: player } = await supabase
        .from('players')
        .select('id')
        .eq('full_name', playerName)
        .maybeSingle();

      if (player) {
        const { data: statsData } = await supabase
          .from('player_season_stats' as any)
          .select('games_played, at_bats, hits, home_runs, rbi, runs_scored, stolen_bases, strikeouts, walks_drawn, errors, innings_pitched, pitcher_wins, pitcher_losses, pitcher_strikeouts, earned_runs, saves, holds, is_pitcher')
          .eq('player_id', player.id)
          .eq('season', 2026)
          .maybeSingle();

        if (statsData) setStats(statsData as any as PlayerSeasonStats);
      }

      setLoading(false);
    };

    fetchData();
  }, [playerName, enabled]);

  return { news, stats, loading };
}
